export function postToParent(messageData) {
  var windowObject = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  if (windowObject.parent) {
    windowObject.parent.postMessage(messageData, '*');
  }
}